import React from 'react';
import { AnyProps } from '../types';

export const RocheAnchorNavigationItem = ({ blok, slot }: AnyProps): JSX.Element => React.createElement('roche-generic-link',
  {
    text: blok.label,
    url: `#anchor-${blok.target_id}`,
    slot,
    icon: blok.icon,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'icon-position': blok.icon_position,
    size: blok.icon_size,
    // eslint-disable-next-line no-underscore-dangle
    uid: blok._uid,
  });
